import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// import Home from './Home';
import App from './App';


// import { BrowserRouter, Routes, Route } from 'react-router-dom';
// import About from "./About";
// import Contact from "./Contact";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
        < App/>
        // <Test/>
  
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
